<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#7bff76" type="square-loader" [fullScreen]="false">
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="content-wrapper new-wrapper">
    <div class="card shadow-sm">
        <div class="card-header bg-white border-0 pb-0">
            <div class="header-top">
                <div class="title-block">
                    <h2 class="mb-1"><i class="fa fa-users me-2"></i>ข้อมูลปริมาณอ้อยเข้าหีบสะสมรายกลุ่ม</h2>
                    <p class="subtitle">ช่วงวันที่: <span class="text-primary">{{choosedate ||
                            'ยังไม่ได้เลือกช่วงวันที่'}}</span></p>
                </div>

            </div>
            <div class="filter-bar">
                <div class="filter-item">
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>เลือกช่วงวันที่</mat-label>
                        <mat-date-range-input [rangePicker]="picker" disabled color="accent">
                            <input matStartDate [(ngModel)]="dateS.date1" min="{{date.date1}}"
                                placeholder="เริ่มวันที่">
                            <input matEndDate [(ngModel)]="dateS.date2" min="{{date.date2}}" placeholder="ถึงวันที่">
                        </mat-date-range-input>
                        <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    </mat-form-field>
                </div>

                <div class="filter-item">
                    <button class="btn btn-danger w-100" (click)="LoadCanebyGroup();">
                        <i class="fa fa-search me-2"></i>ค้นหา
                    </button>
                </div>

                <div class="filter-item">
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>เลือกโซน</mat-label>
                        <mat-select [(ngModel)]="filterList[0]" (selectionChange)="filterData();"
                            [disabled]="canebygroup.length==0">
                            <mat-option value="">-- ทั้งหมด --</mat-option>
                            <mat-option *ngFor="let item of listZones" [value]="item">
                                - {{item}} -
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="filter-item">
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>เลือกประเภทคิว</mat-label>
                        <mat-select [(ngModel)]="filterList[1]" (selectionChange)="filterData();"
                            [disabled]="canebygroup.length==0">
                            <mat-option value=''>-- ทั้งหมด --</mat-option>
                            <mat-option value=1>-- คนตัด --</mat-option>
                            <mat-option value=2>-- รถโยน --</mat-option>
                            <mat-option value=3>-- รถตัด --</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="filter-item" *ngIf="canebygroup.length>0">
                    <div class="pill">รายการที่พบ: <strong>{{filterbygroup.length}}</strong></div>
                </div>
            </div>
        </div>
        <div class="card-body pt-0">
            <div class="table-responsive p-2" style="height: 750px">
                <table class="table table-hover table-striped table-head-fixed table-bordered table-sm table-sticky"
                    #table>
                    <thead>
                        <tr class="text-center">
                            <th colspan="4">
                                <div class="action-block" *ngIf="filterbygroup.length>0">
                                    <button class="btn btn-primary btn-sm" (click)="ExportExcel();">
                                        <i class="fas fa-download me-2"></i>Download Excel
                                        <span class="badge bg-dark ms-2">{{filterbygroup.length}}</span>
                                    </button>
                                </div>
                            </th>
                            <th colspan="6" class="bg-success">ข้อมูลสะสม</th>
                            <th colspan="3" class="bg-warning">ข้อมูลวันนี้</th>
                            <th colspan="2" class="bg-info">วันที่เลือก</th>
                            <th colspan="2" class="bg-success">อ้อยสด</th>
                            <th colspan="3" class="bg-warning">ตัดเสร็จ</th>
                            <th class="bg-primary">คาดการณ์</th>
                        </tr>
                        <tr class="text-center">
                            <th>#</th>
                            <th>รหัสกลุ่ม</th>
                            <th>ชื่อหน.กลุ่ม</th>
                            <th>ประเภทกลุ่ม</th>
                            <th>พื้นที่(ไร่)</th>
                            <th>ประเมิน</th>
                            <th class="bg-primary">CCS</th>
                            <th>อ้อยเข้าหีบ</th>
                            <th>%อ้อยเข้า</th>
                            <th>อ้อยคงเหลือ</th>
                            <th class="bg-warning">เป้าต่อวัน</th>
                            <th class="bg-warning">อ้อยเข้า</th>
                            <th class="bg-success">% เข้าวันนี้</th>
                            <th class="bg-info">อ้อยเข้า</th>
                            <th class="bg-info">CCS</th>
                            <th>อ้อยสด</th>
                            <th>%อ้อยสด</th>
                            <th>พื้นที่ตัดเสร็จ</th>
                            <th>อ้อยประเมิน</th>
                            <th>ผลผลิต</th>
                            <th>คาดวันที่เสร็จ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of filterbygroup; let i = index;" class="text-center">
                            <td>{{i+1}}</td>
                            <td>{{item.groupcode}}</td>
                            <td class="text-start">{{item.h_fmname}}</td>
                            <td class="text-center">
                                <span *ngIf="item.qtype == 1">คนตัด</span>
                                <span *ngIf="item.qtype == 2">รถโยน</span>
                                <span *ngIf="item.qtype == 3">รถตัด</span>
                            </td>
                            <td class="text-end">{{item.area|number:'1.0-1'}}</td>
                            <td class="text-end">{{item.assess|number:'1.0-1'}}</td>
                            <td class="text-end">{{item.ccs|number:'1.0-1'}}</td>
                            <td class="text-end">{{item.canein|number:'1.0-1'}}</td>

                            <td class="text-end">{{item.pccanein|number:'1.0-1'}}</td>
                            <td class="text-end">{{item.caneleft| number:'1.0-1'}}</td>

                            <td class="text-center">{{item.canetargetDate}}</td>
                            <td class="text-end">{{item.caneindate| number:'1.0-1'}}</td>
                            <td class="text-center">{{item.pccanetargetDate| number:'1.0-1'}}</td>

                            <td class="text-end">{{item.canein_be| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.ccs_be| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.caneinFresh| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.pccaneFresh| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.areacuted|number:'1.0-1'}}</td>
                            <td class="text-end">{{item.assesscuted|number:'1.0-1'}}</td>
                            <td class="text-end">{{item.yieldCuted|number:'1.0-1'}}</td>

                            <td>{{item.dateFinish| adtob}}</td>
                        </tr>

                        <tr class="table-success under" *ngFor="let item of sumallbygroup">
                            <td colspan="4" class="text-end">+++ รวม +++</td>
                            <td class="text-end">{{item.sumarea| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.sumassess| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.sumccs| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.sumcanein| number:'1.0-1'}}</td>

                            <td class="text-end">{{item.sumpccanein| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.sumcaneleft| number:'1.0-1'}}</td>

                            <td class="text-end">{{item.sumcanetargetDate| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.sumcaneindate| number:'1.0-1'}}</td>

                            <td class="text-end">{{item.sumpccaneintoday| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.sumcaneinchoose| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.sumccsinchoose| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.sumcaneinFresh| number:'1.0-1'}}</td>
                            <td class="text-end"></td>
                            <td class="text-end">{{item.sumareacuted| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.sumassesscuted| number:'1.0-1'}}</td>
                            <td class="text-end">{{item.sumyieldCuted| number:'1.0-1'}}</td>

                            <td class="text-end"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>